import jwtDecode, { JwtPayload } from 'jwt-decode';

export enum JwtStatus {
  VALID,
  EXPIRED,
  INVALID,
}

export const checkJwtToken = (token?: string): JwtStatus => {
  try {
    if (!token) {
      return JwtStatus.INVALID;
    }
    const decoded: JwtPayload = jwtDecode(token);
    if (decoded.exp && Date.now() >= decoded.exp * 1000) {
      return JwtStatus.EXPIRED;
    }
  } catch (err) {
    return JwtStatus.INVALID;
  }
  return JwtStatus.VALID;
};
